import { jsx as _jsx } from "react/jsx-runtime";
import { Children, useLayoutEffect, useRef, } from 'react';
export function SVGGroup(props) {
    const elementsRefs = useRef([]);
    const { children, direction = 'row', space = 0, ...resProps } = props;
    useLayoutEffect(() => {
        let shift = 0;
        const elements = elementsRefs.current;
        if (!elements) {
            return;
        }
        for (const element of elements) {
            if (element) {
                const boundary = element.getBoundingClientRect();
                if (direction === 'row') {
                    element.setAttribute('transform', `translate(${shift} 0)`);
                    shift += boundary.width + space;
                }
                else {
                    element.setAttribute('transform', `translate(0 ${shift})`);
                    shift += boundary.height + space;
                }
            }
        }
    });
    const items = Children.toArray(children);
    return (_jsx("g", { ...resProps, children: Children.map(items, (child, index) => {
            return (_jsx("g", { ref: (ref) => {
                    if (ref) {
                        elementsRefs.current[index] = ref;
                    }
                }, children: child }, `${index}`));
        }) }));
}
